module.exports = __webpack_public_path__ + "static/media/A18_page_04.de0d758.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/A18_page_04.mp4
// module id = Jplb
// module chunks = 0